/** 샵관리 — 서비스 사용제품(BOM). 서비스 1회당 쓰는 제품·사용량. 시술기록에서 이 값이 기본 채워진다. */
import React from 'react';
import { hiCol } from 'components/grid/hiGrid';
import ShopGridPage from './ShopGridPage';
import {
  loadTable, saveTable, createUid, num, productOptions, serviceOptions, stockSummary,
} from 'shop/shopStore';
import { selectField } from 'shop/shopPageHelpers';

const decorate = (tc) => {
  const stock = new Map(stockSummary(tc).map((s) => [s.productUid, s]));
  const products = new Map(loadTable(tc, 'product').map((p) => [p.productUid, p]));
  return (i) => {
    const unitCost = stock.get(i.productUid)?.headCost || 0;
    return {
      ...i,
      mod: '',
      useUnit: products.get(i.productUid)?.useUnit || '',
      unitCost: Math.round(unitCost),
      costAmount: Math.round(num(i.useQty) * unitCost),
    };
  };
};

const filter = (rows, v) =>
  rows.filter((r) => r.mod !== 'D' && (!v.serviceUid || r.serviceUid === v.serviceUid));

const cfg = {
  gridId: 'sh-service-item',
  title: '서비스 사용제품',
  uidKey: 'itemUid',
  searchDefaults: { serviceUid: '' },
  searchFields: ({ tc }) => [[selectField('serviceUid', '서비스', serviceOptions(tc), '220px')]],
  columns: ({ tc }) => [
    hiCol.edComboColumn({ header: '서비스', field: 'serviceUid', size: 200, required: true, options: serviceOptions(tc), align: 'left' }),
    hiCol.edComboColumn({ header: '사용제품', field: 'productUid', size: 200, required: true, options: productOptions(tc), align: 'left' }),
    hiCol.edNumberColumn({ header: '1회 사용량', field: 'useQty', size: 100, required: true }),
    hiCol.roTextColumn({ header: '사용단위', field: 'useUnit', size: 80, align: 'center' }),
    hiCol.roNumberColumn({ header: '현재 단가(FIFO)', field: 'unitCost', size: 120 }),
    hiCol.roNumberColumn({ header: '1회 원가', field: 'costAmount', size: 100 }),
  ],
  load: (tc) => loadTable(tc, 'serviceItem').map(decorate(tc)),
  filter,
  emptyRow: () => ({ itemUid: createUid('SI'), serviceUid: '', productUid: '', useQty: 1 }),
  validate: (rows) => {
    const errors = [];
    const seen = new Set();
    for (const r of rows) {
      if (r.mod === 'D') continue;
      if (!r.serviceUid) errors.push('서비스를 선택하세요.');
      if (!r.productUid) errors.push('사용제품을 선택하세요.');
      if (num(r.useQty) <= 0) errors.push('사용량은 0보다 커야 합니다.');
      const k = `${r.serviceUid}|${r.productUid}`;
      if (seen.has(k)) errors.push('같은 서비스에 같은 제품이 중복됐습니다.');
      seen.add(k);
    }
    return errors;
  },
  save: (tc, rows, v) => {
    const prev = loadTable(tc, 'serviceItem');
    const inFilter = new Set(prev.filter((r) => filter([r], v).length > 0).map((r) => r.itemUid));
    const outside = prev.filter((r) => !inFilter.has(r.itemUid));
    const active = rows
      .filter((r) => r.mod !== 'D')
      .map((r) => ({
        itemUid: r.itemUid || createUid('SI'),
        serviceUid: r.serviceUid,
        productUid: r.productUid,
        useQty: num(r.useQty),
        sortOrder: num(r.sortOrder) || 10,
      }));
    saveTable(tc, 'serviceItem', [...outside, ...active]);
  },
};

const ServiceItemMaster = () => <ShopGridPage cfg={cfg} />;
export default ServiceItemMaster;
